export default __webpack_public_path__ + "static/media/icon-double-user-add.8e548457.svg";